import { merge } from "theme-ui"
import theme from "@lekoarts/gatsby-theme-cara/src/gatsby-plugin-theme-ui"

export default merge(theme, {
    config: {
        initialColorModeName: 'dark',
        useColorSchemeMediaQuery: false,
    }
})
